export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10154.cbb2c677.jpg";